<template>
<div>  
  <button @click="printPDF()"  type="button"  class="btn btn-info mb-2 mt-2 ">
    <i class="fas fa-print mr-2 "></i>
    STAMPA SHOPPING LIST
  </button>
  
  <div class="table-wrapper-scroll-y shoppingList">


  <table class="table table-sm mb-0 table-hover">

    <thead >
      <tr>
       
        <th>SEDE</th>
        <th>DATA e ORA</th>

        <th scope="col">TIPO</th>
        <th><i  class="fas fa-user-tag" aria-hidden="true"></i></th>
        <th scope="col">EAN</th>
        <th scope="col">ARTICOLO</th>
        <th scope="col">COLORE</th>
        <th scope="col">MISURA</th>
      <!--  <th class="text-right" scope="col">Q.TA'</th>-->
        <th class="text-right" scope="col">IMPORTO</th>
        <th class="text-right" scope="col">SCONTO</th>
        <th class="text-right" scope="col">TOTALE</th>
        <th class="text-right" scope="col">ABBUONO</th>
        <th class="text-right" scope="col">PAGATO</th>
        <th class="text-center" scope="col"></th>
       
        <th></th>
        
        
      </tr>
    </thead>
    <tbody>
      <tr @dblclick="eventLog(item)" class="pointer" :style="{backgroundColor: item.row_type==3 ? '#FFFFE0':'white', color: item.row_type==3  ? 'blue' : 'black',fontSize: item.row_type == 3 ? '20px':'15px',fontWeight:item.row_type == 3 ? 'bold':'normal' }" v-for="(item, index) in items" :key="index">
       
        <td>{{item.store}}</td>
        <td>{{item.create_at}} {{item.hour_at}}</td>        
        <td>
         
          <small v-if="item.row_type == 1" style="color:red" id="reso" class="form-text ">Reso da cliente</small>
          <small v-if="item.row_type == 0" style="color:black" id="vendita" class="form-text ">Vendita</small>
        </td>

         <td ><strong>{{item.assistant_code}} </strong></td>
        <td>{{item.barcode}}</td>
        <td>{{item.brand}} {{item.sku}} {{item.category}} </td>
        
        <td>{{item.color}}</td>
        <td>{{item.size}}</td>
    
        <td :style="{color: item.row_type==3 ? '#FFFFE0':'black'}"  class="text-right">{{fmt1(item.price)}}</td>
        <td class="text-right">{{item.discount}}</td>
        <td class="text-right">{{fmt1(item.row_total)}}</td>
        <td class="text-right">{{fmt1(item.abbuono)}}</td>
        <td :style="{color: item.row_type < 3 ? '#FFFFE0':'blue'}" class="text-right">{{fmt1(item.totalPaid)}}</td>
        <td class="text-right">{{item.paymentType}}</td>
        <td > <i v-if="item.printTicket==1" class="fas fa-print" aria-hidden="true"></i></td>
       
      </tr> 
    </tbody>
    
  </table>


<event-log  v-if="eventData.event_key" @close="eventData.event_key=0" v-bind:item_key="eventData.event_key" v-bind:item_type="eventData.event_type" v-bind:item_header="eventData.event_header"  ></event-log>  
  
  </div>
</div>
</template>
<script>

import eventLog          from '@/components/common/EventLog.vue'
//import axios             from "axios";
import api               from '@/api'
import jsPDF             from 'jspdf';
import fmt               from '@/components/mixins/fmt.js'

//import { format } from 'path';

export default {
  mixins : [fmt],
  components: {eventLog},
  props : ['customerId'],
  data() {
    return {
      
      msg                    : {
        title                : '',
        body                 : '',
        type                 : 0
      }, 
      items                  : [],
      eventData              : {

        event_key            : 0,
        event_type           : '',
        event_header         : ''  
      },
      customer               : '',
     
      
      
    };
  },

  computed :{},
   
 
  mounted: function() {
    this.getShoppingList()
  },
  created: function() {},
  methods: {
    
  eventLog(item)
  {
      if(item.store)
      {
        this.eventData.event_key = item.saleId
        this.eventData.event_type = 'SALE'
        this.eventData.event_header = item.store + '   ' + item.create_at + ' ' + item.hour_at   
      }
      //this.refresh++

    
  },  

    printPDF()
    {
    
      const doc = new jsPDF()

      this.spinner2 = true  
      var page = 1
      
      var pages = parseInt(this.items.length / 50) == this.items.length / 50 ? parseInt(this.items.length / 50) : parseInt(this.items.length / 50) + 1
      
      var row_index = 1
      var page_index = 1
      var init_row = 31
      var row = init_row
      var row_header = row -5

      var col = 5
      var col1 = 15
      var col2 = 45
      var col3 = 70
      var col4 = 100
      var col5 = 121
      var col6 = 150
      var col7 = 165
      var col8 = 185
      var col9 = 205
      var total = 0
      //var row_count = 0
      //var doc = new jsPDF()

      var header = function(customer)
      {
        var d = new Date();
        var n = d.toLocaleString();
        doc.setFontSize(12)
        doc.text('SHOPPING LIST ' ,  105, 10, null, null, "center");
        doc.setTextColor(0, 0, 255);
        doc.text(customer,  105, 15, null, null, "center");
        doc.setTextColor(0, 0, 0);
        
       // doc.text('CASSA ' + description3,  105, 20, null, null, "center");
        
        doc.setFont("helvetica","bold");
      
        doc.setFontSize(10)
      
        doc.text('BRAND', col1,row_header);
        doc.text('CATEGORIA', col2, row_header);
        doc.text('PRODOTTO', col3, row_header);
        doc.text('COLORE', col4, row_header);
        doc.text('MIS.', col5, row_header);

        doc.text('IMPORTO', col6, row_header,null,null,'right');
        doc.text('% SC.', col7, row_header,null,null,'right');
        doc.text('IMPORTO', col8, row_header,null,null,'right');
        doc.text('PAGATO', col9, row_header,null,null,'right');
        doc.setFont("helvetica","normal");

      }
      var footer = function()
      {
        doc.setFontSize(8)
        doc.text('pag. ' + page.toString() + ' / ' + pages.toString(),  105, 290, null, null, "center");
       
      }
      header(this.customer)
      footer()


      this.items.forEach(item=>{
        if(item.row_type == 1)
        {
          //total += Number(item.qty)
        }
        
        
       
        doc.setFontSize(8)
       
       

        //doc.text(row_index.toString(), col, row);
        //doc.text(item.brand.toString().substr(0,15), col1, row);
        if(item.row_type != 3)
        {
          
          doc.setFont("helvetica","bold"); 
                   
        }
       
        if(item.row_number ==  1)
        {
          doc.setFont("helvetica","bold");   
          doc.setFontSize(7)
          doc.text(item.store.toString().substr(0,15) + ' ' + item.create_at, col1, row - 3);  
          

        }
        if(item.row_type < 3)
        {
        doc.setFont("helvetica","normal");   
        doc.text(item.brand.toString().substr(0,15), col1, row);  
        doc.text(item.category.toString().substr(0,20), col2, row);
       
        doc.text(item.sku.toString().substr(0,20), col3, row);
        doc.text(item.color.toString().substr(0,10), col4, row);
        doc.text(item.size.toString().substr(0,5), col5, row);

        doc.text(item.price.toString(), col6, row,null,null,'right');
        doc.text(item.discount.toString(), col7, row,null,null,'right');
        doc.text(this.fmt1(item.row_total.toString()), col8, row,null,null,'right');
        //row_count++

        }  
        if(item.row_type == 3)
        {
          
          //let start_row = row_count + 3
          
          doc.setFont("helvetica","bold");
          doc.setFontSize(10)

          //doc.rect(col + 180, row-3, 19, 4)
          //doc.rect(col + 9, row - 3, 190, 4)
          //doc.rect(col + 9, row - 3, 190, 4)

          doc.text(this.fmt1(item.row_total.toString()), col8, row + .4,null,null,'right');
          doc.text(this.fmt1(item.totalPaid.toString()), col9, row + .4,null,null,'right');
          doc.setFont("helvetica","normal");
          doc.setFontSize(6)
          doc.text(item.paymentType.toString(), col9 , row -3,null,null,'right');
          if(item.abbuono > 0.00)
          {
            doc.text('Abbuono -' + item.abbuono.toString(), col8  , row -3 ,null,null,'right');
          }
          //row_count = 0
          //doc.setFontSize(10)
        }


        
        if(page_index == 50 && row_index < this.items.length)
        {
          page++  
          doc.addPage("a4");
          header(this.customer)
          footer()
          row = init_row
          row_index++
          page_index = 1
        }
        else
        {
          row = row + 5
          row_index++
          page_index++
        }
        
      })
        doc.setFontSize(10)
        //doc.text('TOTALE ' + total ,  200, 285, null, null, "right");
      //doc.save('CheckList_' + Date.now().toString() )
      let fileName = 'CheckList_' + Date.now().toString()
      //this.pdf = doc.output('datauristring');
      window.open(doc.output('bloburl', { filename: fileName }), '_blank');
      this.spinner2 = false
    },

   async getShoppingList() {
    
      

      this.msg.title = ''
      this.items = []
      
      var sp    = {'sp':'spCustomerShoppingList'}
      
      var data  = {'customerId':this.customerId}
      var json  = Object.assign(data, sp)

      await api.post(json).then(res => {
        if(res.status==200)
          {
            this.items = res.data.recordsets[0]  
            
            this.customer = res.data.recordsets[1][0].customer       
          }
          else if(res.status==500)
          {
            console.log(res.data)

          } 
          else
          {
            console.log('Network Error.')                  
          } 
      }).catch(err => 
      {
        console.log(err.message)    
      }).finally(() => {
        
      });


    
    }
  }
};
</script>
<style scoped>

.shoppingList {
position: relative;
height: 500px;
overflow: auto;
}

.pointer:hover
{
 
 
  cursor           : pointer;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
.table-wrapper-scroll-y {
display: block;
}


h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.date_time
{
  font-size: 18px;
}
 .table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}
</style>